// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import dynamic from 'next/dynamic';
import { PropTypes } from 'prop-types';
import { getAspectRatio, parseBoolean } from '@tcp/core/src/utils';
import RenderVideo from './RenderVideo.view';

import { StyledModal, StyledModuleWrapper } from '../DamImage.styles';

const CloudinaryVideoPlayer = dynamic(() => {
  return import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "CloudinaryVideoPlayer" */ '@tcp/core/src/components/common/atoms/CloudinaryVideoPlayer'
  );
});

const PlpPopUpMedia = (props) => {
  const {
    isModule,
    assignKeyValue,
    videoData,
    preloadImage,
    openPlpPopUpMedia,
    setOpenPlpPopUpMedia,
    isEnableMute,
    isHomePage,
  } = props;
  const aspectRatioObj = getAspectRatio(null, videoData, null);

  const toggleModalState = () => {
    setOpenPlpPopUpMedia(false);
  };
  return (
    <StyledModal
      fixedWidth
      isOpen={openPlpPopUpMedia}
      onRequestClose={toggleModalState}
      overlayClassName="TCPModal__Overlay"
      className={`${isHomePage ? 'hp_pop_up_media_modal' : 'plp_pop_up_media_modal'}`}
      maxWidth={`${window.innerWidth * 0.8}px`}
      maxHeight={`${window.innerHeight * 0.6}px`}
      minHeight="300px"
      data-locator={`${isHomePage ? 'hp_pop_up_media_modal' : 'plp_pop_up_media_modal'}`}
      ariaLabelledby="popup media modal"
      ariaDescribedby="popup media modal"
    >
      <StyledModuleWrapper aspectRatioObj={aspectRatioObj}>
        {videoData && parseBoolean(videoData.hls) ? (
          <CloudinaryVideoPlayer
            videoData={videoData}
            isModule={isModule}
            preloadImage={preloadImage}
            assignKeyValue={assignKeyValue}
            makePositionAbsolute
          />
        ) : (
          <RenderVideo
            videoData={videoData}
            isModule={isModule}
            preloadImage={preloadImage}
            makePositionAbsolute
            isEnableMute={isEnableMute}
          />
        )}
      </StyledModuleWrapper>
    </StyledModal>
  );
};

PlpPopUpMedia.propTypes = {
  videoData: PropTypes.shape({
    autoplay: PropTypes.string,
    muted: PropTypes.string,
    controls: PropTypes.string,
    playsinline: PropTypes.string,
    loop: PropTypes.string,
    title: PropTypes.string,
    hls: PropTypes.bool,
  }),
  isModule: PropTypes.bool.isRequired,
  assignKeyValue: PropTypes.string.isRequired,
  preloadImage: PropTypes.bool,
  openPlpPopUpMedia: PropTypes.bool.isRequired,
  setOpenPlpPopUpMedia: PropTypes.func.isRequired,
  isEnableMute: PropTypes.bool,
  isHomePage: PropTypes.bool,
};

PlpPopUpMedia.defaultProps = {
  videoData: {
    autoplay: '1',
    muted: '1',
    controls: '1',
    loop: '1',
    title: 'Video',
    playsinline: '1',
    hls: '1',
  },
  preloadImage: false,
  isEnableMute: false,
  isHomePage: false,
};

export default PlpPopUpMedia;
